import { MaintanceLog } from "@/src/pages/maintenance-logs/models/maintance-log.model";
import { AiReport } from "../models/dashboard.model";

export interface CriticalNotifications {
    date: string,
    message: string,
    notificationId: string
}

export interface ChartData {
    data: number[],
    labels: string[]
}

export interface OfflineForkliftInfo {
    date: string,
    name: string,
    forkliftId?: string | null,
    companyId?: string | null
}

export interface Inventory {
    totalForklift: number,
    offlineForklift: number,
    notInMotion: number,
    off: number,
    inMotion: number,
    offlineForkliftInfo: OfflineForkliftInfo[];
}

export interface DashboardInitialState {
    aiReports: AiReport | null;
    inventory: Inventory;
    criticalNotifications: CriticalNotifications[] | null;
    advancedData: ChartData | null;
    nonEfficient: ChartData | null;
    efficiency: any;
    advencedGraphFilter: boolean;
    maintenanceLogs: MaintanceLog[];
}

const initialDashboardState: DashboardInitialState = {
    aiReports: null,
    inventory: {
        totalForklift: 0,
        offlineForklift: 0,
        notInMotion: 0,
        off: 0,
        inMotion: 0,
        offlineForkliftInfo: []
    },
    criticalNotifications: [],
    advancedData: null,
    nonEfficient: null,
    efficiency: null,
    advencedGraphFilter: false,
    maintenanceLogs: []
}

export default initialDashboardState